import _objectSpread from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import SidebarItem from './SidebarItem';
import _variables from '@/styles/variables.scss';
import Hamburger from '@/components/Hamburger';
export default {
  components: {
    SidebarItem: SidebarItem,
    Hamburger: Hamburger
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebarRoutes', 'sidebar'])), {}, {
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
          path = route.path; // if set path, the sidebar will highlight the path you set

      if (meta.activeMenu) {
        return meta.activeMenu;
      }

      return path;
    },
    variables: function variables() {
      return _variables;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  }),
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    updateSideBar: function updateSideBar() {
      this.$store.dispatch('app/updateSideBar');
    }
  }
};